var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-modal"},[_vm._t("default",function(){return [_vm._v("共通モーダル")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }